import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List, makeSelectable } from 'material-ui/List';
var SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits(SelectableList, _Component);

    var _super = _createSuper(SelectableList);

    function SelectableList(props) {
      var _this;

      _classCallCheck(this, SelectableList);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "handleRequestChange", function (event, index) {
        _this.props.onChange(index);

        if (!_this.props.value) {
          _this.setState({
            selectedIndex: index
          });
        }
      });

      _this.state = {
        selectedIndex: props.defaultValue || props.selectedIndex
      };
      return _this;
    }

    _createClass(SelectableList, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(ComposedComponent, {
          value: this.props.value ? this.props.value : this.state.selectedIndex,
          onChange: this.handleRequestChange,
          style: this.props.style
        }, this.props.children);
      }
    }]);

    return SelectableList;
  }(Component), _defineProperty(_class, "propTypes", {
    children: PropTypes.node.isRequired,
    defaultValue: PropTypes.any.isRequired
  }), _temp;
}

SelectableList = wrapState(SelectableList);
export default SelectableList;